// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1eBRB","notes":"Notes_notes__3_X8z"};